import React from "react";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import Qr from "./Qr"
import TerminalCodeInput from "./TerminalCodeInput"


class Step2 extends React.Component {
  state = {
    terminalCode: (this.props.oldTerminal.terminalData) ? this.props.oldTerminal.terminalData.terminalCode : "",
    isInputActive: true
  }

  getStepModeContent = (modeNum) => {
    switch (modeNum) {
      case 0:
        // Step 1: Instructions and either take a photo of QR code or begin typing ID of old terminal
        return 'Unknown step';
      case 1:
        // Step 2: Take a photo of QR code or type ID of old terminal
        return <Qr handleBack={this.props.handleBack} handleChangeTerminalCodeValue={this.handleChangeTerminalCodeValue} handleChangeMode={this.props.handleChangeMode} />
      case 2:
        // Step 3: Information of old terminal and either take a photo of QR code or begin typing ID of new terminal
        return <TerminalCodeInput handleTerminalValueChange={this.handleTerminalValueChange} handleGetTerminal={this.props.handleGetOldTerminal} terminalCodeInputValue={this.state.terminalCode} terminal={this.props.oldTerminal}/>
      default:
        return 'Unknown step';
    }
  }

  handleTerminalValueChange = (event) => {
    this.setState({
      terminalCode: event.target.value});
  }

  handleChangeTerminalCodeValue = (newValue) => {
    this.setState({
      terminalCode: newValue});
  }

  render() {
    const { mainClasses, modeNum, oldTerminal, handleNext, handleBack } = this.props;
    return (
      <React.Fragment>
        <div>
          <Typography className={mainClasses.stepTitle} variant="title" component="h3">Kirjaa vanha laite</Typography>
        </div>  
          <div>
            { this.getStepModeContent(modeNum) }
            <div className={mainClasses.buttonWrapper}>
              <Button className={mainClasses.stepButton} disabled={!(oldTerminal && oldTerminal.terminalData && oldTerminal.terminalData.stationPump)} variant="contained" color="primary" onClick={() => handleNext(0)}>Jatka</Button>
            </div>
            <div className={mainClasses.buttonWrapper}>
              <Button className={mainClasses.stepButton} variant="outlined" onClick={handleBack}>Back</Button>
            </div>
            
          </div>
      </React.Fragment>
    );
  }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/components/Steps/Step2.js